import React, { useState, useEffect, useLayoutEffect } from "react";
import styles from "./apiList.less";

function AnchorControl({ tableText, id }) {
  const [apilistTop, setApilistTop] = useState(0);
  // const [apilistWidth, setApilistWidth] = useState(null);
  let apiScrollLeft = 0;
  // let tableNode = null;

  useEffect(() => {
    const api = document.querySelector("#api");
    api.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    const apilistTop = Math.round(
      document.querySelector("#api").getBoundingClientRect().top
    );
    const anchorcontrol = document.querySelector("#anchorcontrol");
    setApilistTop(apilistTop);
    anchorcontrol.className = styles.anchorcontrol;
  }, []);

  // useEffect(() => {
  //   const api = document.querySelector("#api");
  //   tableNode = api.querySelectorAll("table")[0];
  //   const tableWidth = tableNode.getBoundingClientRect().width;
  //   const tableLeft = tableNode.getBoundingClientRect().left;
  //   tableWidth && tableLeft && setApilistWidth(tableWidth + tableLeft + 40);
  //   window.addEventListener("resize", handleResize);
  //   return function clearup() {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);

  useEffect(() => {
    let targetIndex = 0;
    const api = document.querySelector("#api");
    const anchors = api.querySelectorAll(".anchor");
    const controledanchors = [...api.querySelectorAll(".controledanchor")];
    api.onscroll = () => {
      //   监听横向滚动条
      if (apiScrollLeft !== api.scrollLeft) {
        apiScrollLeft = api.scrollLeft;
        // const tableNode = api.querySelectorAll("table")[0];
        // const tableWidth = tableNode.getBoundingClientRect().width;
        // const tableLeft = tableNode.getBoundingClientRect().left;
        // setApilistWidth(tableWidth + tableLeft + 40);
      } else {
        const scrollTop = api.scrollTop;
        const controledanchorsTop = controledanchors.map(
          (item) => Math.round(item.offsetTop) - scrollTop
        );
        for (let i = 0; i < controledanchorsTop.length; i++) {
          if (
            api.scrollHeight -
              (api.scrollTop + api.getBoundingClientRect().height) <
            1
          ) {
            targetIndex = controledanchorsTop.length - 1;
          } else {
            if (
              controledanchorsTop[i] <= 30 &&
              controledanchorsTop[i + 1] > 30
            ) {
              targetIndex = i;
            }
          }
        }
        anchors.forEach((item, index) => {
          item.className =
            index === targetIndex ? `anchor ${styles.aHover}` : "anchor";
        });
      }
      return () => {
        api.onscroll = "";
      };
    };
  });

  // const handleResize = () => {
  //   const tableWidth = tableNode.getBoundingClientRect().width;
  //   const tableLeft = tableNode.getBoundingClientRect().left;
  //   tableWidth && tableLeft && setApilistWidth(tableWidth + tableLeft + 40);
  // };

  const handleClick = (e) => {
    const api = document.querySelector("#api");
    const controledanchors = [...api.querySelectorAll(".controledanchor")];

    const targetAnchor = e.target;
    const anchors = api.querySelectorAll(".anchor");

    for (let i = 0; i < anchors.length; i++) {
      if (anchors[i] === targetAnchor) {
        api.scrollTop =
          controledanchors[i].offsetTop - controledanchors[0].offsetTop;
        break;
      }
    }
  };

  return (
    <div
      id="anchorcontrol"
      className={styles.anchorcontrol_init}
      // style={{ marginTop: `${apilistTop + 42}px`, left: `${apilistWidth}px` }}
      style={{ marginTop: `${apilistTop + 42}px`, right: `56px` }}
    >
      <ul onClick={handleClick}>
        <li>
          <a className={`anchor ${styles.aHover}`}>接口基本信息</a>
        </li>
        <li>
          <a className={"anchor"}>请求头参数</a>
        </li>
        <li>
          <a className={"anchor"}>{tableText}</a>
        </li>
        <li>
          <a className={"anchor"}>返回参数</a>
        </li>
        <li>
          <a className={"anchor"}>请求结构示例</a>
        </li>
        <li>
          <a className={"anchor"}>返回结构示例</a>
        </li>
        <li>
          <a className={"anchor"}>API工具</a>
        </li>
      </ul>
    </div>
  );
}

export default AnchorControl;
